let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8OCbm")).then(() => parcelRequire('ff5v9'));